(function (ws) {
    'use strict';
    ws.views.userMenuBox = Backbone.View.extend({

        /**
         * Events
         */
        events: {
            'click #user-menu-a': 'showUserMenuBox'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.userMenuBox = this.$('#user-menu-box');
            this.isVisible = this.userMenuBox.is(':visible');

            $(document).on('click', this.onDocumentClick.bind(this));
            this.$arrowIcon = this.$('.menu-user-arrow-icon');
        },

        /**
         * Toggle class hide for user menu box
         *
         * @param {Event} e
         */
        showUserMenuBox: function (e) {
            e.preventDefault();
            this.userMenuBox.fadeToggle('fast');
            this.isVisible = !this.isVisible;
            this.toggleArrowIcon();
        },

        /**
         * Handle click outside of menu user box
         * and clicks in nav menu
         * hide always when the user doesn't click on menu or arrow
         *
         * @param {Event} e
         */
        onDocumentClick: function (e) {
            const $target = $(e.target);
            const hasClickedOutsideBox = $target.closest('.user-menu-box').length === 0;
            const hasClickedLogoutLink = $target.closest('.comp-logout').length === 1;

            if (hasClickedOutsideBox || hasClickedLogoutLink) {
                this.userMenuBox.fadeOut('fast');
                this.isVisible = false;
                this.toggleArrowIcon();
            }
        },

        /**
         * Toggles the arrow icon from up to down and back.
         */
        toggleArrowIcon() {
            if (this.isVisible) {
                this.$arrowIcon
                    .removeClass('icon-downarrow')
                    .addClass('icon-uparrow');
            }
            else {
                this.$arrowIcon
                    .removeClass('icon-uparrow')
                    .addClass('icon-downarrow');
            }
        }
    });
})(westcon);
